import ThemedElement from "shared/components/ThemedElement";
import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { Search, Clear } from "@mui/icons-material";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import PropTypes from "prop-types";

const SearchBar = ({ searchQuery, onSearchChange, switchesCount }) => {
  const handleClearSearch = () => {
    onSearchChange("");
  };

  return (
    <MDBox px={2} pt={2}>
      <MDBox
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "background.paper",
          borderRadius: 1,
          border: "1px solid",
          borderColor: "divider",
          p: 1,
          maxWidth: 500,
        }}
      >
        <Search sx={{ color: "text.secondary", mr: 1 }} />
        <ThemedElement
          component="input"
          type="text"
          placeholder={`Buscar entre ${switchesCount} switches...`}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{
            border: "none",
            outline: "none",
            flex: 1,
            backgroundColor: "transparent",
            fontSize: "0.875rem",
            color: "text.primary",
          }}
        />
        {searchQuery && (
          <Tooltip title="Limpiar búsqueda" arrow>
            <IconButton size="small" onClick={handleClearSearch}>
              <Clear fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </MDBox>
    </MDBox>
  );
};

SearchBar.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  switchesCount: PropTypes.number,
};

SearchBar.defaultProps = {
  switchesCount: 0,
};

export default SearchBar;
